<template>
  <div>
    <h1>Génération des fiches de livraison</h1>
    <div class="trello-container">
      <div class="table-container">
        <h3>Génération automatique</h3>
        <div class="form-group">
          <label>Sélectionner un tableau :</label>
          <select class="form-control" v-model="model.selectedBoard" @change="loadLists()">
            <option v-for="board in boards" :value="board.id" :key="board.id">{{ board.name }}</option>
          </select>
        </div>
        <br />
        <div class="form-group" v-if="model.selectedBoard != ''">
          <label>Sélectionner une liste :</label>
          <select class="form-control" v-model="model.selectedList">
            <option v-for="list in lists" :value="list.id" :key="list.id">{{ list.name }}</option>
          </select>
        </div>
        <br />
        <div class="form-group" v-if="model.selectedList != ''">
          <button class="btn btn-dark" v-on:click="exportCards()">Exporter</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getBoards, getLists, getCardsByList } from "@/utils/trello";
  import { exportWord } from "@/utils/exportWord";
  import { convertTrelloCards } from "@/helpers/trelloCardToWordConverter";

  export default {
    name: "FicheLivraison",
    data() {
      return {
        boards: [],
        lists: [],
        model: {
          selectedBoard: "",
          selectedList: "",
        },
        listResume: [],
        developers: [],
      }
    },
    mounted() {
      this.loadBoards();
    },
    methods: {
      // Chargement initial des tableaux
      loadBoards() {
        this.boards = [];
        getBoards().then(res => {
          this.boards = res;
        });
      },

      // Chargement des listes d'un tableau
      loadLists() {
        this.lists = [];
        getLists(this.model.selectedBoard).then(res => {
          this.lists = res;
        });
      },

      // Export des cartes de la liste
      exportCards() {
        this.listResume = [];
        this.developers = [];
        getCardsByList(this.model.selectedList).then(res => {
          res.forEach(card => {
            var membersUser = card.idMembers.map(m => this.$store.state.trelloConfig.userConfig.find(e => e.idTrello == m) == undefined ? "" : this.$store.state.trelloConfig.userConfig.find(e => e.idTrello == m).initials).join(', ');
            var labelsString = card.labels.map(l => l.name).join(', ');

            this.developers.push(...card.idMembers.map(m => this.$store.state.trelloConfig.userConfig.find(e => e.idTrello == m) == undefined ? "" : this.$store.state.trelloConfig.userConfig.find(e => e.idTrello == m).initials));

            this.developers = this.developers.filter((ele, pos) => this.developers.indexOf(ele) == pos);

            this.listResume.push({
              id: card.idShort,
              name: card.name,
              description: card.desc,
              startDate: card.start,
              dueDate: card.due,
              dueComplete: card.dueComplete,
              url: card.shortUrl,
              members: membersUser,
              labels: labelsString
            });
          })

          this.generateWord();

        })
      },

      // Génère le fichier Word
      generateWord() {
        let formatedContent = convertTrelloCards(
          this.boards.find(b => b.id == this.model.selectedBoard).name,
          this.lists.find(l => l.id == this.model.selectedList).name,
          this.listResume,
          this.developers.join(', '),
        );

        const fileName = this.getFileName(
          this.boards.find(b => b.id == this.model.selectedBoard).name.replace("Suivi ", "").replace(".", " ").toUpperCase(),
          this.lists.find(l => l.id == this.model.selectedList).name.replace("Livraison ", "").toUpperCase()
        )

        exportWord(formatedContent, fileName, "cmem")
      },
      // Crée le nom du fichier
      getFileName(project, version) {
        var today = new Date();
        var day = today.getDate() < 10 ? "0" + today.getDate().toString() : today.getDate().toString();
        var month = (today.getMonth() + 1) < 10 ? "0" + (today.getMonth() + 1).toString() : (today.getMonth() + 1).toString();
        var datetime = day + "-" + month + "-" + today.getFullYear().toString()

        return project + " - " + version + " - " + datetime;
      }

    },
  }
</script>

<style scoped>
  .trello-container {
    display: grid;
    grid-template-columns: 500px 1fr;
    column-gap: 24px;
  }

  .table-container {
    padding: 1rem;
    border-radius: 12px;
    background-color: white;
    box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.4);
    overflow-x: hidden;
  }

  .table-container .heading {
    display: flex;
    justify-content: space-between;
  }

  .priorityBadge {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: black;
    margin: auto;
  }

  .priorityBadge.priority-0 {
    background-color: transparent;
    border: 1px solid #CCC;
  }

  .priorityBadge.priority-1 {
    background-color: rgb(237, 215, 71);
  }

  .priorityBadge.priority-2 {
    background-color: rgb(242, 162, 64);
  }

  .priorityBadge.priority-3 {
    background-color: rgb(218, 100, 79);
  }

  .boards-summarize {
    list-style-type: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    row-gap: 12px;
  }

  .boards-summarize .board-box {
    width: 100%;
    background-color: white;
    box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.4);
    border-radius: 12px;
    padding: 1rem;
  }

    .boards-summarize .board-box h3 {
      font-size: 1.15rem;
      font-weight: bold;
      position: relative;
      padding-bottom: 15px;
      margin-bottom: 15px;
      border-bottom: 2px solid #F3F3F3;
    }

    .boards-summarize .board-box .badges {
      list-style-type: none;
      padding: 0;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 8px;
    }

    .badges .priority-badge {
      width: 100%;
      padding: 0.5rem 0.7rem;
      color: white;
      font-size: 0.8rem;
      border-radius: 8px;
      display: flex;
      align-items: center;
    }

      .badges .priority-badge:nth-child(1) {
        background-color: rgb(237, 215, 71);
      }

      .badges .priority-badge:nth-child(2) {
        background-color: rgb(242, 162, 64);
      }

      .badges .priority-badge:nth-child(3) {
        background-color: rgb(218, 100, 79);
      }

  .board-box .progress-bar {
    display: grid;
    justify-content: start;
    width: 100%;
    height: 16px;
    overflow: hidden;
    background-color: white;
    border: 1px solid #A7C13C;
    border-radius: 12px;
    margin-bottom: 15px;
    margin-top: 8px;
  }

    .board-box .progress-bar div:nth-child(1) {
      background-color: #A7C13C;
    }

    .board-box .progress-bar div:nth-child(2) {
      background-color: rgb(242, 162, 64);
    }

</style>

<style>


  .card-table {
    max-width: 100%;
    overflow-x: scroll;
  }

    .card-table table,
    .card-table thead,
    .card-table thead th,
    .card-table th,
    .card-table td {
      border: none !important;
    }

    .card-table thead {
      border-top: 1px solid #CCC !important;
      border-bottom: 1px solid #CCC !important;
    }

      .card-table thead th {
        background: white;
        text-align: center;
      }

    .card-table td {
      /*max-width: 200px;*/
    }

    .card-table td a {
      color: black;
      text-decoration: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/GestionProjet/FicheLivraison.vue